export default __webpack_public_path__ + "static/media/question.92a56749.svg";